import VueRouter from 'vue-router';
import axios from "axios";


function isWechat():boolean {
    if (navigator.userAgent.toLowerCase().match(/MicroMessenger/i)){
        return true;
    }
    return false;
}

export default function configRouter(router: VueRouter): void {
    router.beforeEach((to, from, next) => {
        if (to.meta && to.meta.title) {
            document.title = to.meta.title;
        } else {
            document.title = '沪学习';
        }


        const imgUrl = "https://f.diyiedu.com/dynb/img/hxx-logo-mini.png";
        const lineLink = location.href;
        const shareTitle = "沪学习-上海官方数字课本学习平台";
        const shareTitle2 = shareTitle;
        const descContent = "会学习，更有趣";

        const url = `https://diyiedu.com/wxjs_config?page=${location.href}`

        const wx = window.wx;

        if (isWechat()) {
            axios({
                method:'get',
                url,
            }).then((rs: any)=> {
                const res = rs.data;
                // eslint-disable-next-line no-undef
                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: res.appId, // 必填，公众号的唯一标识
                    timestamp: res.timestamp, // 必填，生成签名的时间戳
                    nonceStr: res.nonceStr, // 必填，生成签名的随机串
                    signature: res.signature,// 必填，签名
                    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'updateAppMessageShareData'] // 必填，需要使用的JS接口列表
                });

                // eslint-disable-next-line no-undef
                wx.ready(function () {
                    wx.updateAppMessageShareData({
                        title: shareTitle, // 分享标题
                        desc: descContent, // 分享描述
                        link: lineLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: imgUrl, // 分享图标
                        success: function () {
                            //alert('updateAppMessageShareData ok');
                        }
                    })
                });


                // eslint-disable-next-line no-undef
                wx.onMenuShareAppMessage({
                    title: shareTitle,
                    desc: descContent,
                    link: lineLink,
                    imgUrl: imgUrl,
                    type: 'link',
                    dataUrl: '',
                    success: function (res: any) {
                        //alert('onMenuShareAppMessage ok');
                    },
                    cancel: function (res: any) {
                        //alert('onMenuShareAppMessage cancel');
                    }
                });

                wx.onMenuShareTimeline({
                    title: shareTitle2,
                    link: lineLink,
                    imgUrl: imgUrl,
                    success: function (res: any) {
                        //alert('onMenuShareTimeline ok');
                    },
                    cancel: function (res: any) {
                        //alert('onMenuShareTimeline cancel');
                    }
                });

            });
        }
        console.log(222111);
        // 获取远端图片

        next();
    });
}
